import { datadogRum } from '@datadog/browser-rum';
import { jucyInsights } from './jucyInsights';

let env = 'dev';
if (process.env.NEXT_PUBLIC_VERCEL_ENV === 'production') {
    env = 'prod';
}
if (process.env.NEXT_PUBLIC_VERCEL_ENV === 'preview') {
    env = 'test';
}
datadogRum.init({
    applicationId: '4a3662c9-1776-4432-b4f7-31f0ff58e5d2',
    clientToken: 'pub50a5b642010361ea9f6414302fb3f25d',
    site: 'us5.datadoghq.com',
    service: 'turkana',
    env,
    version: process.env.NEXT_PUBLIC_VERCEL_GIT_PULL_REQUEST_ID || process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    enableExperimentalFeatures: ['feature_flags'],
    defaultPrivacyLevel: 'allow',
    allowedTracingUrls: [(url) => jucyInsights.shouldTraceUrl(url)],
    proxy: (options) => `https://${jucyInsights.resolveInsightsDomain(window.location.href)}/ingest${options.path}?${options.parameters}`,
});
